<div class="dialog d-flex direction-column align-center" [formGroup]="rpa">
  <h1 class="dialog-title" mat-dialog-title>
    Inserir Número e Data de Emissão do <strong>RPA</strong>
  </h1>

  <app-c-input
    class="form-input dialog-field mt-30"
    label=""
    formControlName="RpaNumber"
    placeholder="Número RPA"
    inputMask="999999999999"
  >
  </app-c-input>

  <app-c-input
    class="form-input dialog-field mt-30"
    label=""
    formControlName="RpaDate"
    placeholder=""
    inputMask=""
    inputType="datetime-local"
  >
  </app-c-input>

  <div
    class="dialog-actions actions d-flex justify-center mt-36"
    mat-dialog-actions
  >
    <button class="actions-btn ui-btn ui-btn--primary" (click)="close(true)">
      Salvar
    </button>
    <button class="actions-btn ui-btn ui-btn--secondary ml-16" (click)="close(false)">
      Cancelar
    </button>
  </div>
</div>
